import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
    return (
        <div className="d-flex vh-100" style={{ backgroundColor: "var(--background)" }}>
            <Sidebar />
            <div className="flex-grow-1 d-flex flex-column" style={{ backgroundColor: "var(--background)" }}>
                <Header />
                <main className="flex-grow-1 overflow-auto p-3">{children}</main>
            </div>
        </div>
    );
};

export default Layout;
